import { ArchBaseService } from "@/common/api.service";

ArchBaseService.init();

export const InternalUserService = {
  /**
   * Get list of internal users with pagination
   * @param {Object} params - Query parameters
   * @param {Number} params.page - Page number
   * @param {Number} params.size - Items per page
   * @param {String} params.sort - Sort direction (asc/desc)
   * @param {String} params.sortby - Field to sort by
   * @param {String} params.search - Search term
   * @param {String} params.filterby - Field to filter by
   * @param {String} params.filtervalue - Value to filter
   * @param {String} params.condition - Filter condition (==, >=, >, <, <=, like)
   * @returns {Promise}
   */
  getUsers(params) {
    return ArchBaseService.get("internal/user/list", params);
  },

  /**
   * Create a new internal user
   * @param {Object} userData - User data
   * @param {String} userData.email - User email (required)
   * @param {String} userData.firstname - First name (required)
   * @param {String} userData.lastname - Last name (required)
   * @param {String} userData.phonenumber - Phone number (required)
   * @param {String} userData.countryid - Country ID (required)
   * @param {String} userData.functionid - Function ID (required)
   * @param {String} userData.roleid - Role ID (required)
   * @param {String} userData.serviceid - Service ID (required)
   * @param {String} userData.accesstypeid - Access type ID (required)
   * @param {Boolean} userData.twofactorenabled - Two factor enabled (optional)
   * @returns {Promise}
   */
  createUser(userData) {
    return ArchBaseService.create("internal/user/", userData);
  },

  /**
   * Get list of roles
   * @returns {Promise}
   */
  getRoles() {
    return ArchBaseService.get("auth/access/roles");
  },

  /**
   * Get list of functions
   * @returns {Promise}
   */
  getFunctions() {
    return ArchBaseService.get("auth/access/functions");
  },

  /**
   * Get list of services
   * @returns {Promise}
   */
  getServices() {
    return ArchBaseService.get("auth/access/services");
  },

  /**
   * Get list of access types
   * @returns {Promise}
   */
  getAccessTypes() {
    return ArchBaseService.get("auth/access/types");
  },
};

export default InternalUserService;
